import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import './styles/base/__globalStyles.scss';
import './styles/base/_fonts.scss';
import './styles/base/_typography.scss';
import './styles/base/normalize.scss';

import React, { useState, useCallback, useEffect } from 'react';
import Preloader from 'Components/PreLoader/Preloader';
import AIRTool from 'Containers/AITools/AIRTool';
import AITool from 'Containers/AITools/AITool';
import ContentPlanner from 'Containers/Content Planner/ContentPlanner';
import DocumentView from 'Containers/DocumentView/DocumentView';
import FreeStyleEditor from 'Containers/FreeStyleEditor/FreeStyleEditor';
import ResetPasswordModal from 'Containers/Modal/ResetPasswordModal/ResetPasswordModal';
import Documents from 'Containers/Documents/Documents';
import Questionnaire from 'Containers/Questionnaire/Questionnaire';
import Team from 'Containers/Team/Team';
import TeamDetail from 'Containers/TeamDetail/TeamDetail';
import Templates from 'Containers/Templates/Templates';
import Projects from 'Components/Projects/Projects';
import DashboardLayout from 'layouts/DashboardLayout/DashboardLayout';
import BillingScreen from 'Containers/Subscription/BillingScreen';
import ConfirmSubscription from 'Containers/Subscription/ConfirmSubscription';
import Subscription from 'Containers/Subscription/Subscription';
import { actions } from 'redux/slices/auth';
import { getCurrentSubscription } from 'services/subscriptionService';
import { NewUserSubscriptionPlan } from 'Containers/NewUserSubscriptionPlan/NewUserSubscriptionPlan';
import {
  CONTENT_PLANNER,
  EDITOR,
  FOLDER,
  FREESTYLE_EDITOR,
  DOCUMENT,
  DOCUMENTS,
  QUESTIONNAIRE,
  RESEARCH,
  SUMMARIZATION,
  TEAMS,
  TEMPLATES,
  TERMS,
  PRIVACY,
  MCP,
  MCP_DOCS,
  DOCUMENT_HISTORY,
  PROJECTS,
  BILLING_SUBSCRIPTION,
  BILLING_PAYMENT,
  CONFIRM_SUBSCRIPTION,
  SUBSCRIBE_PLAN,
  SUBSCRIPTION,
  UPDATE_PROFILE,
  SUBSCRIPTION_PLAN,
  BILLING_PLAN,
  ONBOARDING,
  NEW_PLAN,
  BRAND,
  INTEGRATION,
  LINKEDIN_CALLBACK,
  X_CALLBACK,
} from './constants';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet, Route, Routes, useLocation, useParams, useSearchParams } from 'react-router-dom';
import Editor from './Containers/Editor';
import LandingPage from 'Components/LandingPage/LandingPage';
import DocumentHistory from 'Containers/DocumentHistory/DocumentHistory';
import EmailVerification from 'Containers/EmailVerification/EmailVerification';
import InviteAccept from 'Containers/InviteAccept/InviteAccept';
import ProjectDetail from 'Components/Projects/ProjectDetail';
import Ideate from 'Containers/Ideate/Ideate';
import Onboarding from 'Containers/Onboarding/Onboarding';
import Step1 from 'Containers/Onboarding/Step1';
import TermsConditions from 'Containers/TermsConditions';
import PrivacyPolicy from 'Containers/PrivacyPolicy';
import MCPLanding from 'Containers/MCP/MCPLanding';
import MCPDocsOverview from 'Containers/MCP/docs/Overview';
import MCPDocsQuickstart from 'Containers/MCP/docs/Quickstart';
import MCPDocsFirstSession from 'Containers/MCP/docs/FirstSession';
import MCPDocsClients from 'Containers/MCP/docs/Clients';
import MCPDocsToolReference from 'Containers/MCP/docs/ToolReference';
import MCPDocsResources from 'Containers/MCP/docs/Resources';
import MCPDocsSecurity from 'Containers/MCP/docs/Security';
import MCPDocsTroubleshooting from 'Containers/MCP/docs/Troubleshooting';
import MCPDocsSkills from 'Containers/MCP/docs/Skills';
import ProfileSetup from 'Containers/Profile/ProfileSetup';
import LifetimeDeal from 'Components/LifetimeDeal/LifetimeDeal';

import Hotjar from '@hotjar/browser';
import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';

import { ROUTES } from 'constants/routes';
import AIProjectPlan from './Components/Projects/ProjectPlan/AIProjectPlan';
import AIProject from 'Components/Projects/AIProject/AIProject';
import AIProjectSetup from 'Components/Projects/AIProject/Setup/AIProjectSetup';
import Dashboard from 'Containers/Dashboard/Dashboard';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { error as errorToast } from 'helpers/toaster';
import PaymentScreen from 'Containers/Subscription/PaymentScreen';
import PlanDetailsScreen from 'Containers/Subscription/PlanDetailsScreen';
import LoginPage from 'Containers/Auth/LoginPage';
import SignUp from 'Containers/Auth/SignUp';
import OnboardingFlow from 'Containers/OnboardingFlow/OnboardingFlow';
import Brand from 'Containers/Brand/Brand';
import BrandsHub from 'Containers/BrandsHub/BrandsHub';
import BrandIntelligence from 'Containers/BrandIntelligence/BrandIntelligence';
import BrandInsightsDashboard from 'Components/BrandInsightsDashboard/BrandInsightsDashboard';
import Integrations from 'Containers/Integrations/Integrations';
import LinkedInCallback from 'Containers/OAuth/Linkedin/LinkedinCallback';
import XCallback from 'Containers/OAuth/X/XCallback';
import SumoSignUp from './Containers/Auth/SumoSignUp';
import MetaPixel from 'Components/MetaPixel/MetaPixel';
import PublicDocument from 'Containers/PublicDocument/PublicDocument';

import onBoardingService from 'services/onBoardingService';

const LIFETIME = '/lifetime';

const ProtectedRoute = ({ user, redirectPath = '/' }) => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const fetchCurrentSubscription = useCallback(async () => {
    try {
      const currentSubscriptionRes = await getCurrentSubscription();
      const currentLicenseData = await onBoardingService.getLicenseData();
      const { data: subscriptionData } = currentSubscriptionRes || {};
      const { data: licenseData } = currentLicenseData || {};
      if (subscriptionData || licenseData) {
        dispatch(
          actions.updateUser({
            user: { subscriptions: subscriptionData, license: licenseData },
          }),
        );
      }
    } catch (error) {}
  }, [dispatch]);

  useEffect(() => {
    fetchCurrentSubscription();
  }, [fetchCurrentSubscription]);

  if (!user?.isLoggedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  const loggedInUser = user?.user || {};

  //   if (pathname === `/${ONBOARDING}` || pathname.startsWith(`/${ONBOARDING}/`)) {
  //     debugger
  // // incase of current_subscription and  active, pass_due,trial allow dashboard
  // // incase of current_subscription incomplete, incomplete-expired, unpaid, cancel restrict to payment screen
  //     if (loggedInUser?.subscriptions?.current_subscription ) {
  //       return <Navigate to="/" replace />;
  //     }
  //     if(!loggedInUser?.subscriptions?.current_subscription && loggedInUser?.subscriptions?.last_subscription?.status === "open" ){
  //       return <Navigate to={`/payment?subscriptionId=${loggedInUser?.subscriptions?.last_subscription?.stripe_price?.id}&overdue=true`} replace />;
  //     }
  //     return <Outlet />;
  //   }

  if (pathname === `/${ONBOARDING}` || pathname.startsWith(`/${ONBOARDING}/`)) {
    let active = loggedInUser?.subscriptions?.current_subscription?.active;
    let status = loggedInUser?.subscriptions?.current_subscription?.status;
    let laststatus = loggedInUser?.subscriptions?.last_subscription?.status;

    // incase of current_subscription and  active, pass_due,trial allow dashboard
    // incase of current_subscription incomplete, incomplete-expired, unpaid, cancel restrict to payment screen
    if (loggedInUser?.license) {
      return <Navigate to="/" replace />;
    }

    if (
      loggedInUser?.subscriptions?.current_subscription &&
      active &&
      (status === 'active' ||
        status === 'past_due' ||
        status === 'trial' ||
        status === 'canceled')
    ) {
      return <Navigate to="/" replace />;
    }
    if (
      !loggedInUser?.subscriptions?.current_subscription &&
      loggedInUser?.subscriptions?.last_subscription &&
      loggedInUser?.subscriptions?.last_subscription.status !== 'trial'
    ) {
      return (
        <Navigate
          state={{
            status: loggedInUser?.subscriptions?.last_subscription?.status,
            subscriptionId:
              loggedInUser?.subscriptions?.last_subscription?.stripe_price?.id,
          }}
          to={`/payment`}
          replace
        />
      );
    }
    if (
      loggedInUser?.subscriptions?.current_subscription &&
      !active &&
      (status === 'canceled' ||
        status === 'incomplete_expired' ||
        status === 'incomplete' ||
        status === 'unpaid')
    ) {
      return (
        <Navigate
          state={{
            status: status,
            subscriptionId:
              loggedInUser?.subscriptions?.current_subscription?.stripe_price
                ?.id,
          }}
          to={`/payment`}
          replace
        />
      );
    }
    return <Outlet />;
  }

  const { subscriptions } = loggedInUser || {};
  const { current_subscription: currentSubscription } = subscriptions || {};
  const hasActiveSubscription =
    currentSubscription && currentSubscription?.active;

  if (pathname.includes(SUBSCRIBE_PLAN)) {
    if (hasActiveSubscription) {
      return <Navigate to={'/'} replace />;
    }
    return <Outlet />;
  }

  // add   !pathname.includes(SUBSCRIBE_PLAN || SUBSCRIPTION) && this might fix on cancel redirect to onboarding
  // !hasCancelSubscription (this will take user to / on login after cancel subscription)

  // Check if user is on lifetime payment flow
  const isLifetimePayment =
    pathname.includes('/payment') && searchParams.get('lifetime') === 'true';

  // Check if user has lifetime intent (should not redirect to onboarding)
  const hasLifetimeIntent = localStorage.getItem('lifetimeDealIntent');

  if (
    loggedInUser &&
    !pathname.includes(SUBSCRIBE_PLAN) &&
    !pathname.includes(CONFIRM_SUBSCRIPTION) &&
    !pathname.includes('/resubscribe-confirmation') &&
    !pathname.includes('/payment') &&
    !hasActiveSubscription &&
    !hasLifetimeIntent // Don't redirect if user has lifetime intent
  ) {
    return <Navigate to={ONBOARDING} replace />;
  }

  // If user has lifetime intent and is on root, redirect to payment
  if (loggedInUser && hasLifetimeIntent && pathname === '/') {
    localStorage.removeItem('lifetimeDealIntent');
    return <Navigate to="/payment?lifetime=true" replace />;
  }

  return <Outlet />;
};

if (process.env.NODE_ENV === 'production') {
  // HOTJAR:
  const siteId = 3622637;
  const hotjarVersion = 6;
  Hotjar.init(siteId, hotjarVersion);

  // GOOGLE TAG MANAGER:
  const containerId = process.env.REACT_APP_GTM_CONTAINER_ID;
  if (containerId) {
    Analytics({
      plugins: [
        googleTagManager({
          containerId,
        }),
      ],
    });
  }
}

// Redirect legacy /brand/:brandId to /brand-intelligence/:brandId
const BrandRedirect = () => {
  const { brandId } = useParams();
  return <Navigate to={`/brand-intelligence/${brandId}`} replace />;
};

function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes - data stays fresh for 5 minutes
            gcTime: 1000 * 60 * 10, // 10 minutes - cache persists in memory for 10 minutes
            refetchOnWindowFocus: false, // Don't refetch when user switches tabs
            refetchOnMount: true, // Do refetch when component mounts if data is stale
            retry: 2, // Retry failed requests twice
          },
        },
        queryCache: new QueryCache({
          onError: (error) => {
            errorToast(error);
          },
        }),
      }),
  );
  const user = useSelector((state) => state.auth);
  const { subscriptions } = user ?? {};
  const { current_subscription: currentSubscriptionPlan } = subscriptions ?? {};

  if (process.env.NODE_ENV === 'production') {
    if (user?.isLoggedIn) {
      Hotjar.identify(user.id, {
        name: user.name,
        email: user.email,
        role: user.role,
        company: user.company,
        sign_in_count: user.sign_in_count,
        last_active_at: user.last_active_at,
      });
    }
  }

  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <MetaPixel />

        <Preloader />
        <DashboardLayout data={user}>
          <Routes>
            {!user?.isLoggedIn && <Route index element={<LandingPage />} />}
            <Route
              path={SUBSCRIPTION_PLAN}
              element={<NewUserSubscriptionPlan />}
            />
            <Route
              path={'log-in'}
              element={!user?.isLoggedIn || new URLSearchParams(window.location.search).has('oauth_redirect') ? <LoginPage /> : <Navigate to="/" />}
            />
            <Route path={'appsumo'} element={<SumoSignUp />} />
            <Route
              path={'sign-up'}
              element={!user?.isLoggedIn ? <SignUp /> : <Navigate to="/" />}
            />
            <Route path={'/payment'} element={<PaymentScreen />} />
            <Route
              path={`summary/plan/:planName/price/:price/type/:type`}
              element={
                user && user.isLoggedIn ? (
                  <ConfirmSubscription />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path={`resubscribe-confirmation/plan/:planName/price/:price/type/:type`}
              element={
                user && user.isLoggedIn ? (
                  <ConfirmSubscription />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route path={TERMS} element={<TermsConditions />} />
            <Route path={PRIVACY} element={<PrivacyPolicy />} />
            <Route path={MCP} element={<MCPLanding />} />
            <Route path={MCP_DOCS} element={<Navigate to={`/${MCP_DOCS}/overview`} replace />} />
            <Route path={`${MCP_DOCS}/overview`} element={<MCPDocsOverview />} />
            <Route path={`${MCP_DOCS}/quickstart`} element={<MCPDocsQuickstart />} />
            <Route path={`${MCP_DOCS}/skills`} element={<MCPDocsSkills />} />
            <Route path={`${MCP_DOCS}/first-session`} element={<MCPDocsFirstSession />} />
            <Route path={`${MCP_DOCS}/clients`} element={<MCPDocsClients />} />
            <Route path={`${MCP_DOCS}/tools`} element={<MCPDocsToolReference />} />
            <Route path={`${MCP_DOCS}/resources`} element={<MCPDocsResources />} />
            <Route path={`${MCP_DOCS}/security`} element={<MCPDocsSecurity />} />
            <Route path={`${MCP_DOCS}/troubleshooting`} element={<MCPDocsTroubleshooting />} />
            <Route path="/public/:token" element={<PublicDocument />} />
            <Route path={EDITOR} element={<Editor />} />
            <Route element={<ProtectedRoute user={user} />}>
              <Route
                path={ONBOARDING}
                element={
                  user && !user.is_onboarded ? (
                    <OnboardingFlow />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route path={NEW_PLAN} element={<OnboardingFlow />} />

              <Route
                index
                element={user?.isLoggedIn ? <Dashboard /> : <LandingPage />}
              />
              <Route
                path={`${EDITOR}/document/:documentId/template/:templateId/:shouldCopy?/:access?`}
                element={<Editor />}
              />
              {/* <Route path={'onboarding'} element={<OnboardingFlow />} /> */}

              <Route
                path={`${EDITOR}/document/:documentId/template/:templateId/:shouldCopy?/:access?`}
                element={<Editor />}
              />
              <Route path={`document/:documentId`} element={<DocumentView />} />
              <Route
                path={`${DOCUMENT_HISTORY}/:documentId`}
                element={<DocumentHistory />}
              />
              <Route
                path={`${FREESTYLE_EDITOR}/document/:documentId/:shouldCopy?/:access?`}
                element={<FreeStyleEditor />}
              />
              <Route path={CONTENT_PLANNER} element={<ContentPlanner />} />
              <Route path={DOCUMENTS} element={<Documents />} />
              <Route
                path={`${QUESTIONNAIRE}/template/:templateId`}
                element={<Questionnaire />}
              />
              <Route
                path={`${CONTENT_PLANNER}/brief/:briefId`}
                element={<ContentPlanner />}
              />
              <Route path={DOCUMENT} element={<Documents />} />
              <Route
                path={FOLDER + '/:folderSlug/:shouldCopy?/:access?'}
                element={<Documents />}
              />
              <Route
                path={DOCUMENT + '/:documentType'}
                element={<Documents />}
              />
              <Route path={TEAMS} element={<Team />} />
              <Route path={`${TEAMS}/:teamId`} element={<TeamDetail />} />
              <Route path={ROUTES.Ideate} element={<Ideate />} />
              <Route path={SUMMARIZATION} element={<AITool />} />
              <Route path={RESEARCH} element={<AIRTool />} />
              <Route path={TEMPLATES} element={<Templates />} />
              <Route path={BRAND} element={<BrandsHub />} />
              <Route path="/brand/:brandId" element={<BrandRedirect />} />
              <Route path="/brand-intelligence" element={<BrandIntelligence />} />
              <Route path="/brand-intelligence/:brandId" element={<BrandIntelligence />} />
              <Route path="/brand-insights/:brandId" element={<BrandInsightsDashboard />} />
              <Route path={INTEGRATION} element={<Integrations />} />
              <Route path={LINKEDIN_CALLBACK} element={<LinkedInCallback />} />
              <Route path={X_CALLBACK} element={<XCallback />} />

              <Route path={ROUTES.Projects} element={<Projects />} />
              <Route path={ROUTES.Project.New} element={<AIProject />} />
              <Route path={ROUTES.Project.Setup} element={<AIProjectSetup />} />
              <Route
                path={ROUTES.Project.NewPlan(':projectId')}
                element={<AIProjectPlan flow="newPlan" />}
              />
              <Route
                path={`${PROJECTS}/:projectId`}
                element={<ProjectDetail />}
              />
              <Route
                path={`${PROJECTS}/:projectId/:projectType`}
                element={<ProjectDetail />}
              />
              <Route
                path={`${PROJECTS}/:projectId/folders/:folderSlug`}
                element={<ProjectDetail />}
              />
              {/* <Route path="/onboarding" element={<Onboarding />} /> */}
              {/* <Route path="/onboarding/info" element={<Step1 />} /> */}
              <Route path={SUBSCRIPTION} element={<Subscription />} />
              <Route
                path={`${CONFIRM_SUBSCRIPTION}/plan/:planName/price/:price/type/:type`}
                element={<ConfirmSubscription />}
              />
              <Route path={BILLING_SUBSCRIPTION} element={<BillingScreen />} />
              <Route path={BILLING_PAYMENT} element={<PaymentScreen />} />
              <Route path={BILLING_PLAN} element={<PlanDetailsScreen />} />

              <Route
                path={SUBSCRIBE_PLAN}
                element={
                  <div style={{ marginLeft: 30, marginRight: 30 }}>
                    <Subscription />
                  </div>
                }
              />
              <Route
                path={`${UPDATE_PROFILE}/:form`}
                element={<ProfileSetup />}
              />
            </Route>

            <Route path="/resetPassword" element={<ResetPasswordModal />} />
            <Route path="/signup" element={<LandingPage />} />
            <Route
              path="/email_verfication/:token"
              element={<EmailVerification />}
            />
            <Route
              path="/user_invites/:token/accept"
              element={<InviteAccept />}
            />
            <Route path="*" element={<p>There's nothing here: 404!</p>} />
          </Routes>
        </DashboardLayout>
        {process.env.NODE_ENV === 'development' && (
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
        )}
      </QueryClientProvider>
    </div>
  );
}

export default App;
